<div class="row">
  <div class="col-lg-12">
    <div class="card card-outline-success">
      <div class="card-header">
        <h4 class="m-b-0 text-white">Material en resguardo</h4>
      </div>
      <div class="card-body">
        <div class="tablaDeProductos">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
            <thead>
              <tr style="text-align:center">
                <th>Código</th>
                <th>Descripción</th>
                <th>Cantidad</th>
                <th>Físico</th>
                <th>Mantenimiento</th>
                <th>Inservible</th>
                <th>Enviar</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let espera of arrayEspera" style="text-align:center">
                <td>{{ espera.codigo }}</td>
                <td>{{ espera.descripcion }}</td>
                <td>{{ espera.cantidadRestante }}</td>
                <td>
                  <input class="form-control espera.codigo" style="width: 70px" type="number" name="almacenFisico" (ngModelChange)="calculoCantidades(espera)" [(ngModel)]="espera.fisico">
                  <!-- style="width: 70px" -->
                </td>
                <td>
                  <input class="form-control espera.codigo" style="width: 70px" type="number" name="almacenMantenimiento" (ngModelChange)="calculoCantidades(espera)" [(ngModel)]="espera.mantenimiento">
                </td>
                <td>
                  <input class="form-control espera.codigo" style="width: 70px" type="number" name="almacenInservible" (ngModelChange)="calculoCantidades(espera)" [(ngModel)]="espera.inservible">
                </td>
                <td>
                  <button class="btn btn-success" (click)="enviarCantidades(espera)">Enviar</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/material-resguardo/material-resguardo.component.html